import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  padding: 10px 0px;
  overflow-y: hidden;
  overflow-x: auto;
`